<template>
	<div class="reward_content_list">
		<el-card class="box-card">
			<el-button type="primary" icon='el-icon-plus' @click='dialogCreate=true'>新增</el-button>
			<!-- 列表页 -->
			<el-table :data="rewardContentList" border style="width: 100%;margin-bottom: 10px;">
				<el-table-column prop="gameId" label="游戏ID" width="100">
				</el-table-column>
				<el-table-column prop="gameName" label="游戏名称" width="200">
				</el-table-column>
				<el-table-column prop="rewardContent" label="活动奖励内容" width="600">
				</el-table-column>
				<el-table-column label="操作">
					<template slot-scope="scope">
						<el-button size="mini" @click="proEdit(scope.row)">修改</el-button>
						<el-button size="mini" type="danger" @click="proDelete(scope.row.id)">删除
						</el-button>
					</template>
				</el-table-column>
			</el-table>
		</el-card>

		<!-- 创建账号弹框 -->
		<el-dialog :visible.sync="dialogCreate" ref='createRef' class="createRewardContent">
			<template slot='title'>
				<div style="text-align: center;width: 100%;font-size: 24px;">添加活动奖励内容</div>
			</template>
			<el-form :model="newRewardContent" label-width="100px" size='mini' ref='createRef'>
				<el-form-item prop="gameId" label="抽奖游戏" required>
					<el-select v-model="newRewardContent.gameId" @change="selectChanged(newRewardContent.gameId)" filterable placeholder="请选择抽奖游戏" style="width: 80%" @click.native="getLotteryGameList">
						<el-option
						v-for="item in lotteryGameList"
						:key="item.gameId"
						:label="item.gameName"
						:value="item.gameId">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="活动奖励内容" prop="rewardContent">
					<textarea v-model="newRewardContent.rewardContent" style="width: 400px; height: 250px;"></textarea>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="close">取消</el-button>
				<el-button type="primary" @click="create">提交</el-button>
			</div>
		</el-dialog>

		<!-- 编辑弹框 -->
		<el-dialog title="修改" :visible.sync="dialogEdit" class="updateRewardContent">
			<template slot='title'>
				<div style="text-align: center;width: 100%;font-size: 24px;">修改活动奖励内容</div>
			</template>
			<el-form :model="editRewardContent" label-width="80px" size='mini' :rules="caseRules" ref='updateRef'>
				<el-form-item prop="gameId" label="抽奖游戏">
					<el-select v-model="editRewardContent.gameId" placeholder="请选择抽奖游戏" autocomplete="off" :disabled="true">
						<el-option
						v-for="item in lotteryGameList"
						:key="item.gameId"
						:label="item.gameName"
						:value="item.gameId">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="奖励内容" prop="rewardContent">
					<textarea v-model="editRewardContent.rewardContent" style="width: 400px; height: 250px;"></textarea>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer" style="margin-top: -25px;">
				<el-button @click="dialogEdit = false">取消</el-button>
				<el-button type="primary" @click="update">修改</el-button>
			</div>
		</el-dialog>
	</div>
</template>
 
<script>
import manageApi from "../api/manage"
	export default {
		data() {
			return {
				lotteryGameList: [],
				rewardContentList: [],
				//创建
				dialogCreate: false,
				dialogEdit: false,
				editRewardContent: {},
				newRewardContent: {
					rewardContent: '',
					gameId: '',
					gameName: ''
				}
			}
		},
		methods: {
			//获取抽奖游戏列表
			getLotteryGameList() {
				manageApi.getLotteryGameList().then((response) => {
					this.lotteryGameList = response.data.lotteryGameList
				})
			},
			selectChanged(value) {
				for (let i = 0; i < this.lotteryGameList.length; i++) {
					if (this.lotteryGameList[i].gameId === value) {
						this.newRewardContent.gameName = this.lotteryGameList[i].gameName
					}
				}
			},
			close() {
				this.dialogCreate = false
				this.newRewardContent.rewardContent = ''
			},
			create() {
				manageApi.addRewardContent(this.newRewardContent).then((res)=>{
					if (res.code === 200) {
						this.$message({
							type: 'success',
							message: res.data.message,
							duration: 1000
						});
						// 更新页面的数据
						this.getList()
						// 关闭弹框
						this.dialogCreate = false
						this.close()
					} else {
						this.$message({
						message: res.data.message,
						type: 'error',
						duration: 1000
						});
					}
				})
			},
			proEdit(value) {
				this.editRewardContent = {
					...value
				}
				// 显示编辑框
				this.dialogEdit = true
			},
			async update() {
				manageApi.updateRewardContent(this.editRewardContent).then((res)=>{
					if (res.code === 200) {
						this.$message({
							type: 'success',
							message: res.data.message,
							duration: 1000
						});
						// 更新页面的数据
						this.getList()
						// 关闭弹框
						this.dialogEdit = false
					} else {
						this.$message({
						message: res.data.message,
						type: 'error',
						duration: 1000
						});
					}
				})
			},
			async proDelete(id) {
				console.log('当前删除的数据id为：', id)
				manageApi.deleteRewardContent(id).then((res) => {
					if (res.code === 200) {
						this.$message({
							type: 'success',
							message: res.data.message,
							duration: 1000
						});
						// 更新页面的数据
						this.getList()
					} else {
						this.$message({
						message: res.data.message,
						type: 'error',
						duration: 1000
						});
					}
				})
			},
			// 获取列表
			async getList() {
				manageApi.getRewardContentList().then((res) => {
					if (res.code === 200) {
						this.rewardContentList = res.data.rewardContentList
					} else {
						this.$message({
						message: res.data.message,
						type: 'error',
						duration: 1000
						});
					}
				})
			}
		},
 
		// vue实例数据挂载之后，出触发这个钩子函数
		mounted() {
			this.getList()
		}
 
	}
</script>
 
<style scoped>
.createRewardContent {
	width: 80%;
	margin: 0 auto;
}
</style>